import { Component, ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn } from '@angular/forms';

import { AuthenticationService } from '../../_services/authentication.service';


@Component({
  selector: 'app-customerservice',
  templateUrl: './customer-service.component.html',
  styleUrls: ['./customer.component.css']
})

export class CustomerserviceComponent implements OnInit {

  @ViewChild('closebutton',{static: false}) closebutton;

  ViewCustomer: any = {};
  ViewProduct: any = {};
  ViewProductpgw: any = {};
  
  loadcustomreconnect = false;
  loadcustomsuspend = false;
  openSuspendReconnect = false;
  errorsusrec = false;
  errorsusrecmsg = '';
  supsendreconnecttextarea = '';
  suspendnotes: any = {};

  form: FormGroup;
  formpgw: FormGroup;
  data: any = {};
  datapgw: any = {};
  futuremodel : any = [];

  flagging:any = {};

  formAct = this.fb.group({
    id: [''],
    productname: [''],
    
  })
  
  setdonenotes : string = '';
  permision : string[] = [];
  listproduct = [];
  listproductpgw = [];
  searchproduct = '';
  searchpromo = '';
  Layanan = [];
  Layananpgw = [];
  Services = [];
  Servicelist = [];
  customer = [] ;
  detStb = [] ;
  customerid : string;
  partnerid : number;
  stbid : number;
  loading_create = false;
  activationloading = false;
  alert_failed = false;
  alert_success = false;
  table_load = false;
  table_data = false;
  isAct = "";
  ServiceIndex = null;
  errorprov = false;
  resultprov = [];
  statuserrserviceprov = [];
  msgserviceprov = [];
  emailatv : string;
  errormsgprov : string;
  OrderServices : [];
  identity : [];
  currentuser : any = {};

  producttype : number;
  billingtypeid : number;
  ButtonSavePostpaid = false;
  varmodaldone : any;

  subservices:any = [];

  constructor(
	  private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
	  public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private formBuilder: FormBuilder,
    private Auth: AuthenticationService,
  ) {

    this.form = this.formBuilder.group({
      listproduct: new FormArray([], minSelectedCheckboxes(1)),
      
    });

    this.formpgw = this.formBuilder.group({
      
      listproductpgw: new FormArray([], minSelectedCheckboxes(1))
    });

    
    

   }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    //console.log(this.currentuser);
    this.permision = this.currentuser.permision;
  	this.loadStart();
    // console.log(this.permision);
    

  }
  
  isRole(_role){
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == _role) {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  loadStart() {
    this.customerid = this.route.snapshot.paramMap.get('id');
    this.loadCustomer(this.customerid);
    this.loadServices(this.customerid);
    this.loadOrderService(this.customerid);
    //this.loadProducts('?billingtype=1');
  }


  private addCheckboxes() {

     
    const listproduct = <FormArray>this.form.controls.listproduct;
    listproduct.controls = [];
    // console.log(this.ViewProduct.data);
    if (this.ViewProduct.data != undefined ) 
    {
        this.ViewProduct.data.map((o, i) => {
          const control = new FormControl(); // if first item set to true, else false

          (this.form.controls.listproduct as FormArray).push(control);
        });
    }

  }

  private addPgwCheckboxes() {

    const listproductpgw = <FormArray>this.formpgw.controls.listproductpgw;
    listproductpgw.controls = [];
    
    // console.log(this.ViewProductpgw);

    if (this.ViewProductpgw.data != undefined ) 
    {

      this.ViewProductpgw.data.map((o, i) => {
        const control = new FormControl(); // if first item set to true, else false

        (this.formpgw.controls.listproductpgw as FormArray).push(control);
      });
    }

  }

  isadmin(item: any)
  {
    /*console.log(item)

    return (item.status == false);
    */

    return this.isAdministrator();

  }

  // filter
  isAdministrator()
  {
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'Administrator') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  isPartner()
  {
    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'Partner') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  isWIC()
  {

    if (this.currentuser != null) {
            
        if (this.currentuser.role.roleName == 'OperatorWIC' || this.currentuser.role.roleName == 'Superbranch') {
            return true;
        }else{
            return false;
        }
        
    }else{
      return false;
    }
  }

  manageByWIC()
  {
    if ( this.customer['manageby'] == 1) 
    {
      return true;
    } else {
      return false;
    }
  }


  // partner == perner id
  PartnerIsMe()
  { 
  // console.log(this.currentuser );
  // console.log('partner : '+this.partnerid );
    if (this.currentuser != null) {
        if ( this.currentuser.partner != null){    
          return ( this.partnerid == this.currentuser.partner.partnerid );
        }else{
          return false;
        }
        
    }else{
      return false;
    }
    
  }


  isNew(item: any)
  {
    return (item.servicestatus == 0);
  }

  isCustomerActive()
  {
    return (this.customer['customersts'] == 10);
  }

  isCustomerNew()
  {
    return (this.customer['customersts'] == 0);
  }

  hasService()
  {
   return (this.Services.length>0);
  }

  hasOrderService(){
    //console.log(this.OrderServices);
   return (this.OrderServices.length > 0);
  }

  isActive(item: any)
  {
    return (item.servicestatus == 1);
  }

  isNotnew(cust: any)
  {
    let id = cust.customerstatus.id
    //console.log(id);
    // if (id = 0) {

    // }
    // let service = '';
    // if ( item.pairingto == null || item.pairingto == 0 ){
    //   return service;
    // }else{
    //   item.customer.services.forEach(function (value) {
    //     service += value.servicename + '\n';
    //   });

    //   return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    // }
  }

  isNotActive(item: any)
  {
    return (item.servicestatus == 2);
  }

  isPaymentQuota(item: any)
  {
    return (item.paymenttype == 1);
  }

  isPaymentPgw(item: any)
  {
    if ( !this.Auth.conf.showInProduction )
    return this.Auth.conf.showInProduction;
    
    return ( 
      (item.orderstatus == 0 || (item.orderstatus == 1 && item.prosesactive == 0)) 
      && item.paymenttype == 2);
  }

  isPaymentSubmited(item: any)
  {
    return (item.orderstatus == 1 && item.prosesactive == 1);
  }


  openPGW()
  {
    if ( !this.Auth.conf.showInProduction )
    return this.Auth.conf.showInProduction;

    return this.Auth.conf.openpgw;
    
  }

  
  /* tambahkan service prepaid */
  postOrderServicePrepaid()
  {

    const selectedOrderIds = this.form.value.listproduct
    .map((v, i) => v ? {"productsale_id":this.Layanan[i].productid} : null)
      .filter(v => v !== null);


      // console.log(selectedOrderIds);

      //this.data = {customer_id : 2, services :  "[{\"productsale_id\":1},{\"productsale_id\":2}]" };

      this.data = {partner_id: this.partnerid, customer_id : this.customerid, stb_id: this.stbid, services :  JSON.stringify(selectedOrderIds) };

      
    return this.partnerService.PostOrderServicePrepaid(this.data).subscribe((output: any) => {
      // console.log(output);
      if (output.status) {
        
        
        this.loading_create = false
        // this.loadServices(this.customerid);
        this.ngOnInit()
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false
      } else {
        
        
        this.loading_create = false
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }
  
    })
  }

  postOrderServicePrepaidPGW()
  {

    // console.log(this.formpgw.value.listproductpgw);

    const selectedOrderIds = this.formpgw.value.listproductpgw
    .map((v, i) => v ? {"productsale_id":this.Layananpgw[i].id} : null)
      .filter(v => v !== null);


      // console.log(selectedOrderIds);

      //this.data = {customer_id : 2, services :  "[{\"productsale_id\":1},{\"productsale_id\":2}]" };

      // payment by pgw
      this.datapgw = {partner_id: this.partnerid, paymenttype:2, customer_id : this.customerid, stb_id: this.stbid, services :  JSON.stringify(selectedOrderIds) };
 
    return this.partnerService.PostOrderServicePrepaidpgw(this.datapgw).subscribe((output: any) => {
      // console.log(output);
      if (output.status) {
        
        
        this.loading_create = false
        // this.loadServices(this.customerid);
        this.ngOnInit()
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false
      } else {
        
        
        this.loading_create = false
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }
  
    })
  }

  /* tambahkan service prepaid */
  postServicePrepaid()
  {

    const selectedOrderIds = this.form.value.listproduct
    .map((v, i) => v ? {"productsale_id":this.Layanan[i].productid} : null)
      .filter(v => v !== null);


      // console.log(selectedOrderIds);

      //this.data = {customer_id : 2, services :  "[{\"productsale_id\":1},{\"productsale_id\":2}]" };

      this.data = {partner_id: this.partnerid, customer_id : this.customerid, stb_id: this.stbid, services :  JSON.stringify(selectedOrderIds) };

      
    return this.partnerService.PostServicePrepaid(this.data).subscribe((output: any) => {
      // console.log(output);
      if (output.status) {
        
        
        this.loading_create = false
        // this.loadServices(this.customerid);
        this.ngOnInit()
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = true
        this.alert_failed = false
      } else {
        
        
        this.loading_create = false
        this.LoadJsOrder.loadScriptProductStb()
        this.alert_success = false
        this.alert_failed = true
      }
  
    })
  }

  
onOrderRemove(IndexRemoved)
{

  if ( !confirm('Menghapus order layanan  ? ') ){
    return;
  }

  let service = this.OrderServices[IndexRemoved];
  // console.log(service);

  /*jika produk prepaid*/
  this.partnerService.DeleteOrderServicePrepaid({id:service['id'],
  partner_id:this.partnerid}).subscribe((output: any) => {
    //console.log(output['status']);
    if (output['status']){
      this.loadOrderService(this.customerid);
    }else{
      alert(output['message']);
    }
  })

  //console.log(service);
}  

  serviceRemoved(IndexRemoved)
  {
    let service = this.ViewCustomer.data.services[IndexRemoved];
    // console.log(service);
    /*jika produk prepaid*/
    this.partnerService.DeleteServicePrepaid({id:service['id'],partner_id:this.partnerid}).subscribe((output: any) => {
      // console.log(output['status']);
      if (output['status']){
        this.ViewCustomer.data.services.splice(IndexRemoved,1);
        //this.Services.splice(IndexRemoved,1);
      }else{
        alert(output['message']);
      }
    })

    //console.log(service);
  }

  serviceRemovedUrgent(IndexRemoved)
  {
    let service = this.ViewCustomer.data.services[IndexRemoved];
    // console.log(service);
    /*jika produk prepaid*/
    this.partnerService.DeleteServicePrepaidurgent({id:service['id'],partner_id:this.partnerid}).subscribe((output: any) => {
      // console.log(output['status']);
      if (output['status']){
        this.ViewCustomer.data.services.splice(IndexRemoved,1);
        //this.Services.splice(IndexRemoved,1);
      }else{
        alert(output['message']);
      }
    })

    //console.log(service);
  }
  

  serviceActivationATV(s)
  {

    // if(confirm("Are you sure to delete "+name)) {
    //   console.log("Implement delete functionality here");
    // }else {
    //   console.log("Gagal")
    // }
    //alert(this.customer['billingtype'] + ' '+ this.customer['billingtypename'] + ' actifkan ');
    
    if ( this.customer['email2'] == null ){
     
      this.emailatv = this.customer['email'];
    }else{
      this.emailatv = this.customer['email2'];
    }

    if ( this.customer['billingtype'] == 1 ){ // prepaid
        let service = this.ViewCustomer.data.services[s];
        this.partnerService.ActivationServicePrepaid({
          id:service.id, 
          serviceid: service.serviceid,
          partner_id:this.partnerid,
          email: this.emailatv ,
          sn: this.customer['stbsn'], 
          customer_id:this.customer['id']
          })
          .subscribe((output: any) => {
            // console.log(output);
            this.ViewCustomer.data.services[s]['servicestatus'] = 1;
          });


    }else if ( this.customer['billingtype'] == 2 ){ 

        let service = this.ViewCustomer.data.services[s];
        this.partnerService.ActivationService({
          id:service.id, 
          stb: this.detStb,
          product:service}).subscribe((output: any) => {
        // console.log(output);
        
          this.ViewCustomer.data.services[s]['servicestatus'] = 1;
          
        });

    }

    return;
    
  }

  serviceActivation(s)
  {

    // if(confirm("Are you sure to delete "+name)) {
    //   console.log("Implement delete functionality here");
    // }else {
    //   console.log("Gagal")
    // }
    //alert(this.customer['billingtype'] + ' '+ this.customer['billingtypename'] + ' actifkan ');
    
    if ( this.customer['email2'] == null ){
     
      this.emailatv = this.customer['email'];
    }else{
      this.emailatv = this.customer['email2'];
    }

    if ( this.customer['billingtype'] == 1 ){ // prepaid
        let service = this.ViewCustomer.data.services[s];
        this.partnerService.ActivationServicePrepaid({
          id:service.id, 
          serviceid: service.serviceid,
          partner_id:this.partnerid,
          email: this.emailatv ,
          sn: this.customer['stbsn'], 
          customer_id:this.customer['id']
          })
          .subscribe((output: any) => {
            // console.log(output);
            this.ViewCustomer.data.services[s]['servicestatus'] = 1;
          });


    }else if ( this.customer['billingtype'] == 2 ){ 

        let service = this.ViewCustomer.data.services[s];
        this.partnerService.ActivationService({
          id:service.id, 
          stb: this.detStb,
          product:service}).subscribe((output: any) => {
        // console.log(output);
        
          this.ViewCustomer.data.services[s]['servicestatus'] = 1;
          
        });

    }

    return;
    
  }

  serviceNotActivation(s)
  {
    alert('Yakin tidak aktif');
    let service = this.ViewCustomer.data.services[s];
    this.partnerService.DeactivationService({id:service.id}).subscribe((output: any) => {
    // console.log(output['status']);
      if ( output['status'] ){
        this.ViewCustomer.data.services[s]['servicestatus'] = 2;
      }
    })
  }

  onActionclick(act: any, id: any, index) {
    this.isAct = act;

    // console.log(index);
    // console.log(this.Services);
    this.Servicelist = this.Services[index];
    this.ServiceIndex = index;
    // console.log(this.Servicelist);
    
    //alert(this.customer['billingtype'] + ' ' + this.customer['billingtypename']);
    
    /*return this.partnerService.GetServices(id).subscribe((output: any) => {
      // console.log(output.data);
      this.Servicelist = output.data
      // this.formAct.setValue(output.data);
    })
    */
  }

  
  loadCustomer(id: any) {
    this.table_load = true;
   this.setflag('view','loading',true); 
   return this.partnerService.GetViewCustomer(id).subscribe((output: any) => {
    //return this.partnerService.GetViewCustomerArray(id).subscribe((output: any) => {
      // console.log(output);
      if ( output.status == true ){
        this.setflag('view','allowed',true);
        this.ViewCustomer = output;
        this.identity = output.identity;
        this.customerid = this.ViewCustomer.data.id;
        this.partnerid = this.ViewCustomer.data.partnerid;
        this.customer = this.ViewCustomer.data;
        //console.log(this.ViewCustomer.data.services);
        //this.Services = this.ViewCustomer.data.services;
        
        this.detStb = this.ViewCustomer.data;
        if ( this.detStb['stb'] != undefined )
        {  
          this.stbid = this.detStb['stb']['id'];
        } else {
          this.stbid = 0;
        }
        // console.log(this.stbid);

        this.table_load = false;
        this.table_data = true;
        this.isNotnew(this.customer);
        this.loadsubLayanan();
        this.GetCustomersuspendnote();
      }else{
        this.setflag('view','allowed',false);

      }
      this.setflag('view','loading',false);
    })
  }

  loadOrderService(id){
    return this.partnerService.GetOrderServiceCustomer(id).subscribe((output: any) => {
      // console.log(output);
      this.OrderServices = output.data;
      
    })
  }
  
  totalService : number;
  totalServicepgw : number;

  // produk tanpa quota
  loadProducts(params:any) {
    return this.partnerService.GetProduct(params).subscribe((output: any) => {
      // console.log(output);
      this.ViewProduct = output;
      this.Layanan = this.ViewProduct.data;
      this.addCheckboxes();
      this.totalService = this.ViewProduct.meta.totalCount;
      
    })
  }

  onbuttonstock()
  {
    this.searchproduct = ''
    let producttype = 3; // add on
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    let 
        _params = '?partnerid='+this.customer['partnerid'];
        _params = _params+'&producttype='+producttype;

    this.loadQuotaPrepaidProduct(_params);
  }


  searchLayananstock()
  {
    let producttype = 3; // add on
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    let searchText = this.searchproduct;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&partnerid='+this.customer['partnerid'];
        _params = _params+'&producttype='+producttype;
      
    this.loadQuotaPrepaidProduct(_params);
  }
  // produk dengan quota
  loadQuotaPrepaidProduct(params:any) {
    return this.partnerService.GetQuotaPrepaidProductcheck(params).subscribe((output: any) => {
      // console.log(output);
      this.ViewProduct = output;
      this.Layanan = this.ViewProduct.data;
      this.addCheckboxes();
      this.totalService = this.Layanan.length;
      
    })
  }

  loadLayanan()
  {
    // jika billing type == prepaid
    // if ( this.customer['billingtype'] == 1 ) {
      this.loadQuotaPrepaidProduct('?partnerid='+this.customer['partnerid']+'&billingtype='
      +this.customer['billingtype']+'&servicetype='+this.customer['servicetype']+'&producttype=1');
    // }

  }

  loadsubLayanan()
  {
    return this.partnerService.GetSubServiceCustomer('?id='+this.customer['id']).subscribe((output: any) => {
      // console.log(output);
      this.subservices = output.data;
      
    });
  }

  onbuttonpgw()
  {

    this.searchproduct = ''
    let producttype = 3; // add on
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    this.searchproduct = ''
    let _params = '?billingtype=1&producttype='+producttype;
    this.loadLayananpgw(_params);
  }

  onbuttondone(service)
  {

    this.settomodaldone(service);
  }

  onbuttonstockpromo()
  {
    
    let producttype = 4; // promo
    if ( this.customer['customersts'] != 10 ){
      return
    }

    let searchText = this.searchpromo;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&billingtype=1&producttype='+producttype;
      
    this.loadLayananpgw(_params);
  }

  searchLayananpgw()
  {
    let producttype = 3; // add on
    let billingtype = this.customer['billingtype']; 
    if ( this.producttype != undefined ){
      producttype = this.producttype;
    }

    if ( this.billingtypeid != undefined ){
      billingtype = this.billingtypeid;
    }
    
    if ( this.customer['customersts'] == 0 ){
      producttype = 1; // starter
    }

    let searchText = this.searchproduct;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&billingtype='+billingtype+'&producttype='+producttype;
      
    this.loadLayananpgw(_params);
  }

  loadLayananpgw(params:any)
  {
    // only add ons
    // '?billingtype=1&producttype=2'
      return this.partnerService.GetProductatv(params).subscribe((output: any) => {
        // console.log(output);
        this.ViewProductpgw = output;
        this.Layananpgw = this.ViewProductpgw.data;
        this.addPgwCheckboxes();
        this.totalServicepgw = this.Layananpgw.length;
        
      });
    //this.loadQuotaPrepaidProduct('?partnerid='+this.customer['partnerid']+'&billingtype='
    //  +this.customer['billingtype']+'&servicetype='+this.customer['servicetype']);
    //loadQuotaPrepaidProduct 
  }

  //button

  searchService()
  {
    let searchText = this.searchproduct;
    //  _params = '?billingtype=1';
    let _params = '?search='+searchText;
        _params = _params+'&partnerid='+this.customer['partnerid'];
        _params = _params+'&billingtype='+this.customer['billingtype'];
        _params = _params+'&servicetype='+this.customer['servicetype'];
      
    this.loadProducts(_params);
  }


  loadServices(id: any){
    
    this.partnerService.GetCustomerService('?id='+id).subscribe((output: any) => {
      //console.log(output);
      this.Services = output.data;
    })
  }

  submit() {
    //this.postService();
    if ( this.customer['billingtype'] == 1 ) { // prepaid
      this.postServicePrepaid();
    }

    // console.log(this.Layanan);
    // console.log(this.form.value.listproduct);
    this.ngOnInit()

  }

  // prepaid
  submitNew(){
    //this.postService();
    if ( this.customer['billingtype'] == 1 ) { // prepaid
      this.postOrderServicePrepaid();
    }

    // console.log(this.Layanan);
    // console.log(this.form.value.listproduct);
    this.ngOnInit()

  }

  // prepaid
  submitPgwNew()
  {
    //if ( this.customer['billingtype'] == 1 ) { // prepaid
        this.postOrderServicePrepaidPGW();
    //}
  }

  //prepaid
  customerActivation()
  {
    if (!confirm('Yakin untuk aktifasi account berikut ? ') ){
      return;
    }
    
    let data = {account_id:this.customer['id'], partner_id: this.partnerid, servicetype:this.customer['servicetype'], billingtype : this.customer['billingtype'], services: this.customer['services']};
    this.activationloading = true;
    return this.partnerService.PostActionActivationPrepaid(data).subscribe((output: any) => {
      if (output.status){
        this.loadCustomer(this.customer['id']);
      }else{
        alert(output.message);
      }
      this.activationloading = false;
    });

  }

//------------ ACTIVATION ATV NEW --------------------

// activation service per record 
disableATVservice = [];
prosesaktifasi = [];
erroraktifasi = [];
errormsgaktifasi = [];
ATVActivationService(item)
{
  // console.log(item);
  if (!confirm ('Yakin untuk melakukan aktifasi?'))
  {
    return;
  }
 // console.log(item);
  if (item.billingtypeid==2) { // pospaid  

    if (this.customer['pretopost'] != 1 ){
      alert('Status Postpaid belum di submit di bss');
      return;
    }
  }

  
  this.disableATVservice[item.serviceid] = true;
  this.prosesaktifasi[item.serviceid] = true;
   this.erroraktifasi[item.serviceid]=false;
  
  this.partnerService.ATVActivationService(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid] = true;
        this.errormsgaktifasi[item.serviceid] = output.message;
        // console.log(this.errormsgaktifasi);
      }
      this.activationloading = false;
    });


}

/* aktifasi ulang jika ada yang gagal aktif */
reATVActivationService(item)
{
  // console.log(item);
  if (!confirm ('Yakin untuk melakukan aktifasi?'))
  {
    return;
  }
 // console.log(item);
  if (item.billingtypeid==2) { // pospaid  

    if (this.customer['pretopost'] != 1 ){
      alert('Status Postpaid belum di submit di bss');
      return;
    }
  }

  
  this.disableATVservice[item.serviceid] = true;
  this.prosesaktifasi[item.serviceid] = true;
   this.erroraktifasi[item.serviceid]=false;
  
  this.partnerService.REATVActivationService(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid] = true;
        this.errormsgaktifasi[item.serviceid] = output.message;
        // console.log(this.errormsgaktifasi);
      }
      this.activationloading = false;
    });

}

//GetCustomerService
loadService(item)
{
  if (!confirm ('Yakin untuk melakukan aktifasi?'))
  {
    return;
  }
 
 if (item.billingtypeid==2) { // pospaid  

    if (this.customer['pretopost'] != 1 ){
      alert('Status Postpaid belum di submit di bss');
      return;
    }
  }

  
  this.disableATVservice[item.serviceid] = true;
  this.prosesaktifasi[item.serviceid] = true;
  this.erroraktifasi[item.serviceid]=false;
  
  this.partnerService.reloadSubService(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid] = true;
        this.errormsgaktifasi[item.serviceid] = output.message;
        // console.log(this.errormsgaktifasi);
      }
      this.activationloading = false;
    });

}

reloadSubService(item)
{
  if (!confirm ('Yakin untuk melakukan aktifasi?'))
  {
    return;
  }
 
 if (item.billingtypeid==2) { // pospaid  

    if (this.customer['pretopost'] != 1 ){
      alert('Status Postpaid belum di submit di bss');
      return;
    }
  }

  
  this.disableATVservice[item.serviceid] = true;
  this.prosesaktifasi[item.serviceid] = true;
  this.erroraktifasi[item.serviceid]=false;
  
  this.partnerService.reloadSubService(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid] = true;
        this.errormsgaktifasi[item.serviceid] = output.message;
        // console.log(this.errormsgaktifasi);
      }
      this.activationloading = false;
    });

}

/* checkout = melakukan pembayaran  by quota */

ATVCheckoutService(item)
{
  // console.log(item);
  if (!confirm ('Yakin untuk menambahkan service ini ?'))
  {
    return;
  }
  
  this.disableATVservice[item.serviceid] = true;
  this.prosesaktifasi[item.serviceid] = true;
   this.erroraktifasi[item.serviceid]=false;
  
  this.partnerService.ATVCheckoutService(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
        this.loadOrderService(this.customer['id']);
        
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid]=true;
        // console.log(output.message);
        alert(output.message);
      }
      this.activationloading = false;
    });
}

CheckoutServicePGW(item)
{
  // console.log(item);

  if ( item.billingtypeid == 2 ) // pospaid
  {
    if (!confirm ('Service ini Pospaid, Yakin untuk set pada customer?'))
    {
      return;
    }

    this.disableATVservice[item.serviceid] = true;
    this.prosesaktifasi[item.serviceid] = true;
    this.erroraktifasi[item.serviceid]=false;

    this.APICheckoutServicePospaid(item);

  } else {
    if (!confirm ('Yakin untuk set pembayaran service ini ?'))
    {
      return;
    }
  
  
    this.disableATVservice[item.serviceid] = true;
    this.prosesaktifasi[item.serviceid] = true;
    this.erroraktifasi[item.serviceid]=false;

    this.APICheckoutServicePGW(item);
  }
}

APICheckoutServicePGW(item)
{
  this.partnerService.CheckoutServicePGW(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
        this.loadOrderService(this.customer['id']);
        
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid]=true;
        // console.log(output.message);
        alert(output.message);
      }
      this.activationloading = false;
    });
}

APICheckoutServicePospaid(item)
{
  this.partnerService.CheckoutServicePospaid(item).subscribe((output: any) => {
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
        this.loadOrderService(this.customer['id']);
        
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid]=true;
        // console.log(output.message);
        alert(output.message);
      }
      this.activationloading = false;
    });
}

/* CHECK SN DAN USER ID */

tocheckingsn = true;
ischeckingsn = false;
isactivation = false;
iserror = false;
msgerror = '';

CheckingSN()
{
  this.ischeckingsn = true;
  this.tocheckingsn = false;
  this.activationloading = true;
  this.iserror = false;

  return this.partnerService.PostATVCheckSN({sn:this.customer['stbsn'],customerid:this.customerid,custstbid:this.stbid}).subscribe((output: any) => {
    if ( output['status'] ){
        //alert(output['userid']);
        this.ischeckingsn = false;
        this.isactivation = true;

        // activasi
        this.partnerService.PostATVServiceActivation({userid:output['userid'], 
        stbid: this.stbid, customerid:this.customerid})
        .subscribe((outputx: any) => {
        // console.log(outputx);
          if (outputx['status'])
          {
              this.activationloading = false;
              this.ischeckingsn = false;
              this.tocheckingsn = true;
              this.isactivation = false;
              this.customer['customersts'] = 10;
              this.loadStart();     
              
          }else{
            this.activationloading = false;
            this.ischeckingsn = false;
            this.tocheckingsn = true;
            this.isactivation = false;
            alert('Maaf ada error : ' + outputx['message']);
          }
          

        });

      } else {
        this.iserror = true;
        this.msgerror = output['message'];
        this.activationloading = false;
        this.ischeckingsn = false;
        this.tocheckingsn = true;
        
      }
      

    }, (error )=>{
       alert(error);
      // console.log(error);
      
    });
}

//------------ END ACTIVATION ATV NEW --------------------



  setLogin()
  {
    let data = {email:'Whetska.septiardi@gmail.com',sn:'19053000000006',customer_id:this.customer['id']};
    // return this.partnerService.ATVLogin(data).subscribe((output: any) => {
    //   console.log(output);
    // }); 
  }


  PrepaidActivation()
  {
    // console.log(this.customer);
    // console.log(this.customer['email2']);

    
    if ( this.customer['email2'] == null ){
     
      this.emailatv = this.customer['email'];
    }else{
      this.emailatv = this.customer['email2'];
    }
   

    let data = {email: this.emailatv ,partner_id:this.partnerid, sn: this.customer['stbsn'], customer_id:this.customer['id']};

    this.activationloading = true;
    return this.partnerService.PrepaidActivation(data).subscribe((output: any) => {
       // console.log(output);
       if ( output.status ) {
         
         // console.log(output.result);
         let a = output.result;
         for (let key in a) {
            // console.log(a[key]);
            this.resultprov[key] = a[key];
            // true jika error
            if ( !this.resultprov[key]['status'] ){
              this.statuserrserviceprov[key] = true;
            }
            this.msgserviceprov[key] = this.resultprov[key]['message'];
         }
         //this.activationloading = false;
         this.loadCustomer(this.customer['id']);
       }else{
        this.errorprov = true;
        this.errormsgprov = output.message;

       
       }
       this.activationloading = false;
        
    }); 
  }

  ResultProv(key)
  {
    if (this.resultprov.indexOf(key) == -1){
      return true;
    }else{
      if ( this.resultprov[key]['status'] ){
        return true;
      }else{
        return false;
      }
    }
  }

  AllowSuspend()
  {
    if ( this.customer != undefined ){
      if ( this.customer['customersts'] == 10)
      {
        return true;
      } else {
        return false;
      } 
    }else{
      return false;
    } 
  }

  disableloadcustomsuspend(){
    //console.log(this.supsendreconnecttextarea,this.loadcustomsuspend);
    if ( this.loadcustomsuspend ){
      return true;
    }else{
      if ( this.supsendreconnecttextarea == ''){
        console.log(this.supsendreconnecttextarea);
        return true;
      }else{
        return false;
      }
    }
    //return true;
    //return this.loadcustomsuspend;
  }

  disableloadcustomreconnect(){
    //console.log(this.supsendreconnecttextarea,this.loadcustomsuspend);
    if ( this.loadcustomreconnect ){
      return true;
    }else{
      if ( this.supsendreconnecttextarea == ''){
        console.log(this.supsendreconnecttextarea);
        return true;
      }else{
        return false;
      }
    }
    //return true;
    //return this.loadcustomsuspend;
  }

  AllowReconnect()
  {
    if ( this.customer != undefined ){
      if ( this.customer['customersts'] == 130)
      {
        return true;
      } else {
        return false;
      } 
    }else{
      return false;
    } 
  }

  AllowAddService()
  {
    if ( this.customer != undefined ){
      if ( this.customer['customersts'] == 80 || this.customer['customersts'] == 70 || this.customer['customersts'] == 40 || this.customer['customersts'] == 50 || this.customer['customersts'] == 60 || this.customer['customersts'] == 130)
      {
        return false;
      } else {
        return true;
      } 
    }else{
      return false;
    } 
  }

setOpenSuspendReconnect(){
  if ( this.openSuspendReconnect ){
    this.openSuspendReconnect = false;
  }else{
    this.openSuspendReconnect = true;
  }
}


PostCustomerSuspend()
{
  this.loadcustomsuspend = true;
  this.errorsusrec = false;
  
  return this.partnerService.PostCustomerSuspend({customerid:this.customer['id'],'note':this.supsendreconnecttextarea}).subscribe((output: any) => {
     if ( output.status){
        this.customer['customersts'] = output.data.customer.customersts;
        this.customer['customerstatusname'] = output.data.customer.customerstatusname;
        this.loadServices(this.customer['id']);
        this.loadsubLayanan();
        this.GetCustomersuspendnote();
        this.loadcustomsuspend = false;
     }else{
        this.errorsusrec = true;
        this.errorsusrecmsg = output.message;
     }
     this.loadcustomsuspend = false;
    })

}


PostCustomerReconnect()
{
  this.loadcustomreconnect = true;  
  this.errorsusrec = false;
  return this.partnerService.PostCustomerReconnect({customerid:this.customer['id'],'note':this.supsendreconnecttextarea}).subscribe((output: any) => {
     if ( output.status){
        this.customer['customersts'] = output.data.customer.customersts;
        this.customer['customerstatusname'] = output.data.customer.customerstatusname;
        this.loadServices(this.customer['id']);
        this.loadsubLayanan();
        this.GetCustomersuspendnote();
        this.loadcustomreconnect = false;
       } else {
        this.errorsusrec = true;
        this.errorsusrecmsg = output.message;
      }
        this.loadcustomreconnect = false;
     
    })

}

GetCustomersuspendnote()
{
  return this.partnerService.GetCustomersuspendnote(this.customer['id']).subscribe((output: any) => {
     if ( output.status){
        this.suspendnotes = output.data;
       }
    })

}


viewPackage()
  {
    let data = {email:'Whetska.septiardi@gmail.com',sn:'19053000000006',customer_id:this.customer['id']};
    // return this.partnerService.ATVViewPackage(data).subscribe((output: any) => {
    //   console.log(output);
    // });

  }

  openInfoUser = false;
  userinfo = [];
  vcon = [];
  Showatvuserid()
  {
    this.openInfoUser  = false;
    return this.partnerService.ATVShowUserId({sn:this.customer['stbsn']}).subscribe((output: any) => {
      // console.log(output); 
      //this.showuserinfo  = true;
      this.openInfoUser  = true;
      if ( output.status ){ 
        if (output.data == null){
          this.userinfo = [];
          this.vcon = output.vcon;

        }else{
          this.userinfo = output.data;
          this.vcon = output.vcon;

        }
      }
       // console.log(this.userinfo);  
    })
  }


  openformfuture(id){
    this.flagging[id] = {'formfuture' : true};
  }


  setflag(id,key,val)
  {
    // console.log(id,key,val);
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = val;
    }
    if ( this.flagging[id][key] == undefined){
      this.flagging[id][key] = val;
    }

    this.flagging[id][key] = val;
    // console.log(this.flagging[id]);
  }

  flag(id,key){
    if ( this.flagging[id] == undefined ){
      this.flagging[id] = {};
      this.flagging[id][key] = false;
    }else if (this.flagging[id][key] == undefined ) {
      this.flagging[id][key] = false;
    }

//    console.log(this.flagging[id]);
//    console.log(this.flagging[id][key]);
    return this.flagging[id][key];
  }

  saveFutureAction(id)
  {
    // console.log(this.futuremodel[id]);
    let actiondate = this.futuremodel[id];

    return this.partnerService.PostAddActiveFutureaction({actiondate:actiondate,id:id}).subscribe((output: any) => {
      
      // console.log(output); 
      if ( output.status == true ){

         //this.loadCustomer(this.customerid);
         this.loadServices(this.customerid);
      
      }else{
        alert(output.data['message']);
      }

       // console.log(this.userinfo);  
    })

  }

  removeFutureaction(id)
  {
    if ( !confirm('Yakin untuk reset future action? '))
    {
      return false;
    }

    return this.partnerService.PostRemoveFutureaction({id:id}).subscribe((output: any) => {
      
      // console.log(output); 
      if ( output.status == true ){
        this.loadServices(this.customerid);
      }

       // console.log(this.userinfo);  
    })

  }

  showuser(x)
  {
    // console.log(this.userinfo);
    // console.log(x);
    if ( this.userinfo == undefined ){
      return '';
    } else {
      if (this.userinfo[x] == undefined){
        return '';
      }else{
        return this.userinfo[x];
      }
    }
  }

  serviceremovable()
  {
  
  }

 PostpaidNotes : string;
  switchPostpaid()
  {
    
    this.ButtonSavePostpaid = true;
  }

  ButtonPostPaidSaving = false;
 
  SavePostPaid() {
    this.ButtonPostPaidSaving = true;
    this.ButtonSavePostpaid = false;
    
    // check available 
    
    return this.partnerService.PostAvailabletopostpaid( {customer_id:this.customerid}).subscribe((output: any) => {
        if ( output.status ){
          return this.partnerService.Changebillingcust(this.customerid, {id:this.customerid,billingtype:2,notes:this.PostpaidNotes}).subscribe((output: any) => {
              if ( output.status ){
                //this.loadCustomer(this.customerid);
                this.customer['billingtype'] = 2;
                this.customer['billingtypename'] = 'Postpaid';

              } else {
                // console.log("gagal");
                this.ButtonSavePostpaid = true;

              }      
              
              this.ButtonPostPaidSaving = false;
            
            });

        } else {
          // console.log("gagal");
          alert(output.message);

          this.ButtonSavePostpaid = true;

        }      
        
        this.ButtonPostPaidSaving = false;
      
      });

    
  }

  ButtonPretoPostSaving = false;
  ButtonSetToProst = false;
  SetPretopost()
  {
    
    // checking product pospaid
    this.ButtonPretoPostSaving = true;
    this.ButtonSetToProst = true;
    
    return this.partnerService.Postcheckingpostpaidservice({customer_id:this.customerid}).subscribe((output: any) => {
        if ( output.status ){
          // set to pospaoid
          return this.partnerService.Postprepaidtopostpaid({customer_id:this.customerid}).subscribe((output: any) => {
              if ( output.status ){
                this.customer['pretopost'] = 1;
                //this.loadCustomer(this.customerid);

              } else {
                // console.log("gagal");
                alert('gagal');                
              }   
              
              this.ButtonPretoPostSaving = false;
              this.ButtonSetToProst = false;   
              
          });

        } else {
          // console.log("gagal");
          alert('tidak ada produk postpaid');
          
        }
        this.ButtonPretoPostSaving = false;
        this.ButtonSetToProst = false;
        
      });

    

  }

  MyPermission(p)
  {
    //console.log(this.permision);
    if ( this.permision == undefined ){
      //console.log(p + ': tidak ada' );
      return false;
    }
    
    if (this.permision.indexOf(p) > -1){
      //console.log(p + ': ada' );
      return true;
    }else{
      //console.log(p + ': tidak ada' );
      return false;
    }

  }

  Servicefuture(service)
  {
    if ( service.future != undefined){
      return service.future.actiondate;
    }else{
      return '-';
    }
  }

  ServicefutureEnd(service)
  {
    if ( service.future != undefined){
      return service.future.periodeend;
    }else{
      return '-';
    }
  }

  isproductservice(_service)
  {

    if ( _service.producttypeid == 1 || _service.producttypeid == 2 || _service.producttypeid == 3 || _service.producttypeid == 4 || _service.producttypeid == 9){
      return true;
    }else{
      return false;
    }

  }


  settomodaldone(service)
  {
    this.varmodaldone = service;
    // console.log(this.varmodaldone);
  }

  SaveDone()
  {
    this.varmodaldone
    let item = this.varmodaldone;
    item['notes'] = this.setdonenotes;  
    // console.log(item);
    this.partnerService.ATVActivationService(item).subscribe((output: any) => {
    // console.log(output);
      if (output.status){
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.loadCustomer(this.customer['id']);
      }else{
        this.disableATVservice[item.serviceid] = false;
        this.prosesaktifasi[item.serviceid] = false;
        this.erroraktifasi[item.serviceid] = true;
        this.errormsgaktifasi[item.serviceid] = output.message;
        // console.log(this.errormsgaktifasi);
      }
      this.activationloading = false;
      
    });
    this.closebutton.nativeElement.click();
  }

}



function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
      .map(control => control.value)
      .reduce((prev, next) => next ? prev + next : prev, 0);

    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}


